module.exports = __webpack_public_path__ + "static/media/banner2_2x.df3b5071.jpg";